module.exports = __webpack_public_path__ + "img/Terminal.4669132a.png";